<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>金字塔列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="openPyram()">添加</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="pyramData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" sortable prop="name" label="金字塔名称" width="160"></el-table-column>
            <el-table-column align="center" sortable prop="description" label="描述" width="160"></el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="300">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="getPyramxq(scope.row)">查看金字塔详情</el-button>
                    <el-button size="mini" type="primary" @click="openPyram(scope.row)">修改</el-button>
                    <el-button size="mini" type="danger" @click="delePyram(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 编辑界面 -->
        <el-dialog :title="tit" :visible.sync="editFormVisiible" width="40%">
            <el-form label-width="120px">
                <el-form-item label="金字塔名称">
                    <el-input size="small" v-model="name" auto-complete="off" placeholder="请输入金字塔名称"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input size="small" v-model="description" auto-complete="off" placeholder="请输入金字塔描述"></el-input>
                </el-form-item>
                <el-form-item :label="item.name" v-for="(item, index) in taskTagLst" :key="index">
                    <el-input placeholder="请输入分值" type="number" v-model="item.score" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="addPyram()"
                    v-if="tit == '添加'">添加</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upPyram()"
                    v-if="tit == '修改'">修改</el-button>
            </div>
        </el-dialog>

        <!-- 金字塔详情 -->
        <el-dialog title="金字塔详情页：" :visible.sync="editFormDetails">
            <el-form label-width="120px">
                <el-form-item label="金字塔名称：" prop="name">
                    <span v-html="this.Details.name"></span>
                </el-form-item>
                <el-form-item label="描述："  >
                    <span v-html="this.Details.description"></span>
                </el-form-item>

                <el-form-item :label="item.name"   v-for="(item, index) in taskTagLst" :key="index">
                    <el-input placeholder="请输入分值" type="number" v-model="item.score" />
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { getPyramidList } from '../../api/userMG'
import { getPyramidInfo } from '../../api/userMG'
import { addPyramid } from '../../api/userMG'
import { deletePyramid } from '../../api/userMG'
import { upPyramid } from '../../api/userMG'
import { getTaskTagList } from '../../api/userMG'
export default {
    data() {
        return {
            pyramData: [],
            editFormDetails: false,
            Details: [],
            editFormVisiible: false,
            loading: false,
            name: '',
            description: '',
            taskNum: '',
            money: '',
            tit: '',
            id: '',
            taskTagLst: [],
            taskTagDetai:[],
            taskTagId1: '',
            taskTagId2: '',
            taskTagId3: '',
            taskTagId4: '',
            taskTagId5: '',
            taskTagId6: '',
            taskTagValue1: '',
            taskTagValue2: '',
            taskTagValue3: '',
            taskTagValue4: '',
            taskTagValue5: '',
            taskTagValue6: '',
        }
    },
    created() {
        this.getdata(1);
        this.getTaskTagListFn()
    },
    methods: {
        getTaskTagListFn() {
            getTaskTagList().then(res => {
                console.log('res====', res)
                this.taskTagLst = res.data.list
            })
        },
        // 删除
        delePyram(row) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                let data = {
                    id: row.id
                }
                deletePyramid(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getdata(1)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 修改
        upPyram() {
            this.loading = true,
                upPyramid({
                    id: this.id,
                    name: this.name,
                    description: this.description,
                    taskTagId1: this.taskTagLst[0].id,
                    taskTagId2: this.taskTagLst[1].id,
                    taskTagId3: this.taskTagLst[2].id,
                    taskTagId4: this.taskTagLst[3].id,
                    taskTagId5: this.taskTagLst[4].id,
                    taskTagId6: this.taskTagLst[5].id,
                    taskTagValue1: this.taskTagLst[0].score,
                    taskTagValue2: this.taskTagLst[1].score,
                    taskTagValue3: this.taskTagLst[2].score,
                    taskTagValue4: this.taskTagLst[3].score,
                    taskTagValue5: this.taskTagLst[4].score,
                    taskTagValue6: this.taskTagLst[5].score,
                }).then((res) => {
                    if (res.code == 200) {
                        this.loading = false
                        this.$message.success(res.msg)
                        this.editFormVisiible = false
                        this.getdata(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg)
                    }
                })
        },
        // 添加
        addPyram() {
            this.loading = true,
                addPyramid({
                    name: this.name,
                    description: this.description,
                    taskTagId1: this.taskTagLst[0].id,
                    taskTagId2: this.taskTagLst[1].id,
                    taskTagId3: this.taskTagLst[2].id,
                    taskTagId4: this.taskTagLst[3].id,
                    taskTagId5: this.taskTagLst[4].id,
                    taskTagId6: this.taskTagLst[5].id,
                    taskTagValue1: this.taskTagLst[0].score,
                    taskTagValue2: this.taskTagLst[1].score,
                    taskTagValue3: this.taskTagLst[2].score,
                    taskTagValue4: this.taskTagLst[3].score,
                    taskTagValue5: this.taskTagLst[4].score,
                    taskTagValue6: this.taskTagLst[5].score,
                }).then((res) => {
                    if (res.code == 200) {
                        this.loading = false
                        this.$message.success(res.msg)
                        this.editFormVisiible = false
                        this.getdata(1)
                    } else {
                        this.editFormVisiible = false
                        this.$message.error(res.msg)
                    }
                })
        },
        // 打开编辑对话框
        openPyram(row) {
            this.editFormVisiible = true;
            if (row != undefined && row != "undefined") {
                this.tit = "修改",
                    this.id = row.id,
                    this.name = row.name;
                this.description = row.description;
                this.taskTagLst[0].score = row.taskTagValue1
                this.taskTagLst[1].score = row.taskTagValue2
                this.taskTagLst[2].score = row.taskTagValue3
                this.taskTagLst[3].score = row.taskTagValue4
                this.taskTagLst[4].score = row.taskTagValue5
                this.taskTagLst[5].score = row.taskTagValue6

            } else {
                this.tit = "添加";
                this.id = ''
                this.name = "";
                this.description = "";
                this.taskTagLst[0].score = 0
                this.taskTagLst[1].score = 0
                this.taskTagLst[2].score = 0
                this.taskTagLst[3].score = 0
                this.taskTagLst[4].score = 0
                this.taskTagLst[5].score =0

            }
        },
        // 关闭编辑对话框
        closeDialog() {
            this.editFormVisiible = false
            this.$message({
                type: 'info',
                message: '已取消编辑'
            })
        },
        // 查看金字塔详情
        getPyramxq(row) {
            this.loading = true;
            this.editFormDetails = true;
            let data = {
                id: row.id
            }
            getPyramidInfo(data).then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    });
                } else {
                    
                    this.Details = res.data.data;
                    return;
                }
            })
        },
        // 获取金字塔数据
        getdata(page) {
            this.loading = true;
            let data = {

            }
            getPyramidList(data).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.pyramData = res.data.list;
                    return;
                } else {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    })
                }
            })
        }
    }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/pyram/Pyram.vue